export default __webpack_public_path__ + "static/media/profile.451058e7.svg";